var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-layout',{attrs:{"spinning":_vm.page.loading}},[_c('div',{staticClass:"excel-parent"},[_c('div',{staticStyle:{"display":"none"},style:(_vm.spreadStyle),attrs:{"id":"excelView"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }